





















































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import Search from "@/components/elements/utility/Search.vue";
import DataTable from "@/components/elements/utility/Table.vue";
import StickyHScroll from "@/components/elements/utility/StickyHScroll.vue";
import UserService from "@/services/user_service";
import { Order } from "@/models/order/order";
import { makeTitleCase } from "@/utility/helpers";
import { OrderStatus } from "@/models/order/helpers";
import { NetSuiteQuoteStatus } from "@/models/netsuite/helpers";
import { Mobile } from "@/mixins/mobile";
import ConfirmClearAll from "@/components/elements/modal/ConfirmClearAll.vue";
import ConfirmDelete from "@/components/elements/modal/ConfirmDelete.vue";
import { OrderMixin } from "@/mixins/orders/mixin";
import { GenericError } from "@/services/error_service";
import { NotificationService } from "@/services/notification_service";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { GlobalGetters } from "@/store/modules/global/types";
import { Roles } from "@/models/user/roles";

@Component({
  components: {
    Search,
    DataTable,
    StickyHScroll,
    ConfirmClearAll,
    ConfirmDelete
  }
})
export default class OrderList extends Mixins(Mobile, OrderMixin) {
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetRole))
  userRole!: string;

  protected makeTitleCase = makeTitleCase;
  protected orderStatus = OrderStatus;
  protected userService = new UserService();
  protected orderStatusKeys = Object.keys(OrderStatus);
  protected loader: any = null;
  private unofficialOrders: Order[] = [];

  // Getter (not a data field): field initializers run before mixin data is
  // merged onto the instance, so this.draftsTabKey would be undefined there.
  protected get tabs(): Array<{ key: string; label: string }> {
    return [
      { key: this.draftsTabKey, label: "Drafts" },
      { key: NetSuiteQuoteStatus.Open, label: "Open" },
      {
        key: NetSuiteQuoteStatus.PendingSalesOrder,
        label: "Pending Sales Order"
      },
      { key: NetSuiteQuoteStatus.Processed, label: "Processed" },
      { key: NetSuiteQuoteStatus.Expired, label: "Expired" },
      { key: "Legacy", label: "Legacy" }
    ];
  }

  // The Processed tab is the only one with a Sales Order # column, so it is the
  // only tab whose search matches on it (see OrderMixin.filteredOrders).
  protected get searchPlaceholder(): string {
    return this.activeTab === NetSuiteQuoteStatus.Processed
      ? "Search by Customer, Quote Name, Quote #, or Sales Order #"
      : "Search by Customer, Quote Name, or Quote #";
  }

  async created(): Promise<void> {
    const label = this.userRole === "admin" ? "All" : "My";
    this.loader = this.$loading.show(
      { opacity: 1 },
      {
        before: this.$createElement("h1", `Obtaining ${label} Quotes`)
      }
    );
    await Promise.all([
      this.prepareNetSuiteQuotes(),
      this.prepareDrafts(),
      this.prepareLegacyQuotes()
    ]);
    this.orders = this.convertDraftsToOrders(this.drafts)
      .concat(this.netSuiteQuotes)
      .concat(this.unofficialOrders);
    if (this.tabCounts[this.draftsTabKey] > 0) {
      this.activeTab = this.draftsTabKey;
    }
    setTimeout(() => this.loader.hide(), 300);
  }

  protected showDeleteModal = false;
  protected draftPendingDelete: Order | null = null;

  protected askDeleteDraft(order: Order): void {
    this.draftPendingDelete = order;
    this.showDeleteModal = true;
  }

  protected closeDeleteDraft(): void {
    this.draftPendingDelete = null;
    this.showDeleteModal = false;
  }

  protected async confirmDeleteDraft(): Promise<void> {
    const order = this.draftPendingDelete;
    this.closeDeleteDraft();
    if (!order?.draft_id) return;
    try {
      await this.deleteDraftAction(order.draft_id);
      this.drafts = this.drafts.filter(d => d.id !== order.draft_id);
      this.orders = this.orders.filter(o => o.draft_id !== order.draft_id);
      NotificationService.show("Draft deleted.", "success");
    } catch (err) {
      GenericError.popup(err.message);
    }
  }

  protected async prepareDrafts(): Promise<void> {
    try {
      // FUPOF-191: drafts are private — the API returns only the current
      // user's quotes, regardless of role.
      this.drafts = await this.quoteDraftService.listQuotes();
    } catch (err) {
      console.warn("Quote drafts unavailable:", err);
      this.drafts = [];
    }
  }

  protected async prepareLegacyQuotes(): Promise<void> {
    try {
      this.unofficialOrders = await this.userService.getUserOrders(
        this.userRole
      );
    } catch (err) {
      console.warn("Legacy quotes unavailable:", err);
      this.unofficialOrders = [];
    }
  }

  protected async prepareNetSuiteQuotes(): Promise<void> {
    try {
      let userNetSuiteQuotes: any[] = [];

      if (this.userRole === Roles.Admin) {
        userNetSuiteQuotes = await this.netSuiteService.getAllNetSuiteQuotes();
      } else if (this.user.netsuite_id) {
        userNetSuiteQuotes = await this.netSuiteService.getMyQuotes();
      }

      this.convertNetSuiteQuotes(userNetSuiteQuotes || []);
    } catch (err) {
      console.error("Error preparing NetSuite quotes:", err);
    }
  }

}
